import Cookies from 'universal-cookie'
import queryString from 'query-string'
const cookies = new Cookies();

class Source {
    getSource() {
        const source = cookies.get('source');

        return source;
    }

    setSource(source) {
        console.log("保存source:" + source);
        cookies.set('source', source, { path: '/' });
    }

    getParam() {
        const parsed = queryString.parse(window.location.search);

        return parsed.source;

        //var paramName = "source";
        //var paramValue = "";
        //var isFound = !1;
        //if (window.location.search.indexOf("?") == 0 && window.location.search.indexOf("=") > 1) {
        //    var arrSource = unescape(window.location.search).substring(1, window.location.search.length).split("&")
        //    var i = 0;
        //    while (i < arrSource.length && !isFound) arrSource[i].indexOf("=") > 0 && arrSource[i].split("=")[0].toLowerCase() == paramName.toLowerCase() && (paramValue = arrSource[i].split("=")[1], isFound = !0), i++
        //}
        //return paramValue == "" && (paramValue = null), paramValue
    }
}

export default Source